import { QueryClient } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "./constants";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES_IN_MS,
    },
  },
});
